<template>
  <div
    class="w-100 d-flex justify-content-between align-items-center"
    style="
      height: 50px;
      background: var(--grey-light);
      padding: 13px 16px;
      border-radius: 8px;
    "
  >
    <section class="d-flex align-items-center">
      <img
        :src="require('@/assets/images/svg/ícone-loja.svg')"
        alt=""
        style="padding-right: 12px"
      />
      <div class="flex-column align-items-center">
        <p
          style="
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            color: var(--grey-medium);
            margin: 0;
          "
        >
          Loja Selecionada
        </p>
        <p
          v-if="storeName != ''"
          style="
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            color: var(--black-medium);
            margin: 0;
          "
        >
          {{ storeName }}
        </p>
      </div>
    </section>
    <img
      v-if="storeName == ''"
      :src="require('@/assets/images/svg/ícone-seta-direita-azul.svg')"
      alt=""
      data-bs-toggle="modal"
      data-bs-target="#modalViewSelectedStores"
    />
  </div>
</template>
<script>
export default {
  name: "SelectedStore",
  props: {
    storeName: String,
  },
};
</script>
